module.exports = __webpack_public_path__ + "static/media/guessNumberImg.6c47ce5e.png";